import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAccountInfo } from '../services/api';
import { handleApiError } from '../utils/helpers';

const AccountInfo = () => {
    const [accountInfo, setAccountInfo] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    // Display data strictly from the user details endpoint (getAccountInfo)

    useEffect(() => {
        const fetchAccountInfo = async () => {
            try {
                setLoading(true);
                setError(null);
                const data = await getAccountInfo();
                setAccountInfo(data);
            } catch (err) {
                if (handleApiError(err, navigate)) return;
                setError('Failed to fetch account information');
            } finally {
                setLoading(false);
            }
        };

        fetchAccountInfo();
    }, [navigate]);

    if (loading) {
        return (
            <div className="flex items-center justify-center min-h-screen">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="max-w-4xl mx-auto p-6">
                <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-6">
                    <h3 className="text-red-800 font-semibold">Error</h3>
                    <p className="text-red-600">{error}</p>
                </div>
            </div>
        );
    }

    return (
        <div className="max-w-4xl mx-auto p-6">
            <h1 className="text-3xl font-bold text-gray-900 mb-8">Account Information</h1>

            {/* Basic Information (from user details endpoint) */}
            <div className="bg-white shadow rounded-lg p-6">
                <h3 className="text-lg font-semibold text-gray-900 mb-4">Basic Information</h3>
                <div className="space-y-3">
                    <div>
                        <span className="font-medium text-gray-700">Name:</span>
                        <span className="ml-2 text-gray-900">{accountInfo?.name ?? 'N/A'}</span>
                    </div>
                    <div>
                        <span className="font-medium text-gray-700">Role:</span>
                        <span className="ml-2 text-gray-900">{accountInfo?.role ?? 'N/A'}</span>
                    </div>
                    <div>
                        <span className="font-medium text-gray-700">Contact Person:</span>
                        <span className="ml-2 text-gray-900">{accountInfo?.contactPerson ?? 'N/A'}</span>
                    </div>
                    <div>
                        <span className="font-medium text-gray-700">Email:</span>
                        <span className="ml-2 text-gray-900">{accountInfo?.email ?? 'N/A'}</span>
                    </div>
                    <div>
                        <span className="font-medium text-gray-700">Phone:</span>
                        <span className="ml-2 text-gray-900">{accountInfo?.phoneNo ?? 'N/A'}</span>
                    </div>
                    <div>
                        <span className="font-medium text-gray-700">Address:</span>
                        <span className="ml-2 text-gray-900">{accountInfo?.address ?? 'N/A'}</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AccountInfo;